<template>
  <div class="min-h-full">
    <Disclosure as="nav" class="bg-brand-dark sticky sm:top-0 z-10" v-slot="{ open }">
      <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div class="flex h-16 items-center justify-between">
          <div class="flex items-center">
            <div class="flex-shrink-0">
              <RouterLink to="/">
                <img class="h-12 w-12" src="/img/120x120-icon.png" alt="RailOps icon" />
              </RouterLink>
            </div>
            <div class="hidden md:block">
              <div class="ml-10 flex items-baseline space-x-4">
                <RouterLink v-for="item in navigation" :key="item.text" :to="item.to" :class="[route.path !== '/' && item.to.name.includes(navSectionName) ? 'bg-brand-light text-white' : 'text-white hover:bg-brand-light hover:bg-opacity-75', 'px-3 py-2 rounded-md font-medium']" :aria-current="item.current ? 'page' : undefined">{{ item.text }}</RouterLink>
              </div>
            </div>
          </div>
          <div class="hidden md:block">
            <div class="ml-4 flex items-center md:ml-6 space-x-4">
              <!-- <button type="button" class="rounded-full p-1 text-sky-200 hover:text-white hover:bg-brand-light focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-600">
                <span class="sr-only">View notifications</span>
                <BellIcon class="h-6 w-6" aria-hidden="true" />
              </button> -->

              <QuickSearch />

              <!-- Profile dropdown -->
              <Menu as="div" class="relative ml-3">
                <div>
                  <MenuButton class="flex max-w-xs items-center rounded-full bg-sky-600 text-sm text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-600">
                    <span class="sr-only">Open user menu</span>
                    <!-- <img class="h-8 w-8 rounded-full" :src="user.imageUrl" alt="" /> -->
                    <span class="inline-block h-8 w-8 overflow-hidden rounded-full bg-gray-100">
                      <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                      </svg>
                    </span>
                  </MenuButton>
                </div>
                <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                  <MenuItems class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none divide-y divide-gray-100">
                    <div class="py-1">
                      <div class="px-4 py-1 text-sm font-bold text-gray-700">
                        {{ userName }}
                      </div>
                      <MenuItem class="hover:bg-gray-100">
                        <RouterLink :to="{ name: 'user.edit.profile' }" class="block px-4 py-2 text-sm text-gray-700">
                          Edit My Profile
                        </RouterLink>
                      </MenuItem>
                    </div>

                    <div class="py-1">
                      <div class="-mt-1 px-4 py-2 text-sm text-gray-700 truncate">
                        <span class="font-bold">Account:</span> {{ accountName }}
                      </div>

                      <MenuItem as="button" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" @click="handleChangeAccount">
                        Change Account
                      </MenuItem>

                      <MenuItem as="button" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" @click="handleChangeAccount">
                        Manage Account
                      </MenuItem>
                    </div>

                    <div class="py-1">
                      <MenuItem as="button" class="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100" @click="handleSignOut">
                        Sign Out
                      </MenuItem>
                    </div>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
          </div>

          <div class="-mr-2 flex md:hidden">
            <QuickSearch />

            <!-- Mobile menu button -->
            <DisclosureButton class="inline-flex items-center justify-center rounded-md p-2 text-brand-light hover:bg-brand-light hover:bg-opacity-75 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-600">
              <span class="sr-only">Open main menu</span>
              <Bars3Icon v-if="!open" class="block h-6 w-6" aria-hidden="true" />
              <XMarkIcon v-else class="block h-6 w-6" aria-hidden="true" />
            </DisclosureButton>
          </div>
        </div>
      </div>

      <DisclosurePanel class="md:hidden">
        <div class="space-y-1 px-2 pt-2 pb-3 sm:px-3">
          <DisclosureButton v-for="item in navigation" :key="item.text" as="template">
            <RouterLink  :to="item.to" :class="[item.current ? 'bg-sky-700 text-white underline' : 'text-white hover:bg-brand-light hover:bg-opacity-75', 'block px-3 py-2 rounded-md text-base font-medium underline underline-offset-2']" :aria-current="item.current ? 'page' : undefined">
              {{ item.text }}
            </RouterLink>
          </DisclosureButton>
        </div>
        <div class="border-t border-sky-700 pt-4 pb-3">
          <div class="flex items-center px-5">
            <div class="flex-shrink-0">
              <!-- <img class="h-10 w-10 rounded-full" :src="user.imageUrl" alt="" /> -->
              <span class="inline-block h-10 w-10 overflow-hidden rounded-full bg-gray-100">
                <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </span>
            </div>
            <div class="ml-3">
              <div class="text-base font-medium text-white">{{ userName }}</div>
              <!-- <div class="text-sm font-medium text-sky-300">{{ user.email }}</div> -->
            </div>
            <!-- <button type="button" class="ml-auto flex-shrink-0 rounded-full border-2 border-transparent bg-sky-600 p-1 text-sky-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-sky-600">
              <span class="sr-only">View notifications</span>
              <BellIcon class="h-6 w-6" aria-hidden="true" />
            </button> -->
          </div>
          <div class="space-y-1 px-2 divide-y divide-sky-700">
            <div>
              <DisclosureButton>
                <RouterLink :to="{ name: 'user.edit.profile' }" class="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-brand-light hover:bg-opacity-75 underline underline-offset-2">
                  Edit My Profile
                </RouterLink>
              </DisclosureButton>
            </div>
            <div class="py-1">
              <div class="block px-3 py-2 text-base font-medium text-white">
                <span class="font-bold">Account:</span> {{ accountName }}
              </div>
              <DisclosureButton as="button" class="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-brand-light hover:bg-opacity-75 underline underline-offset-2" @click="handleChangeAccount">
                Change Account
              </DisclosureButton>
              <!-- <DisclosureButton>
                <RouterLink :to="{ name: 'account' }" class="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-brand-light hover:bg-opacity-75 underline underline-offset-2">
                  Manage Account
                </RouterLink>
              </DisclosureButton> -->
            </div>
            <div>
              <DisclosureButton as="template">
                <button type="button" class="block rounded-md px-3 py-2 text-base font-medium text-white hover:bg-brand-light hover:bg-opacity-75 underline underline-offset-2" @click.prevent="handleSignOut">
                  Sign Out
                </button>
              </DisclosureButton>
            </div>
          </div>
        </div>
      </DisclosurePanel>
    </Disclosure>

    <slot />

    <AccountSelector />

    <PageFooter />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAccountStore, useCollectionStore, useFeatureFlagStore, useUserPreferenceStore } from '@/stores'
import { Disclosure, DisclosureButton, DisclosurePanel, Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline';
import { getCurrentUser, signOut } from '@/services/authService';

import AccountSelector from '@/components/account/AccountSelector.vue';
import PageFooter from '@/components/PageFooter.vue';
import QuickSearch from '@/components/QuickSearch.vue';

const route = useRoute();
const router = useRouter();

const accountStore = useAccountStore();
const collectionStore = useCollectionStore();
const featureFlagStore = useFeatureFlagStore();
const preferenceStore = useUserPreferenceStore();

const currentAccountId = storeToRefs(accountStore).currentId;

const navigation = [
  { text: 'Collections', to: { name: 'collections.list' }, current: false },
  { text: 'Locomotives', to: { name: 'locomotives.list' }, current: false },
  { text: 'Cars', to: { name: 'cars.list' }, current: false },
  { text: 'Setup', to: { name: 'setup.railroads.list' }, current: false },
  // { text: 'Sharing', to: { name: 'share.list' }, current: false },
]

const navSectionName = computed(() => route?.name ? route.name.toString().substring(0, route.name.toString().indexOf('.')) : '');
const userName = ref('');
const accountName = computed(() => accountStore.currentAccount?.accountName ?? 'Unknown');

async function refreshAccountData(forceReload: boolean = false) {
  await collectionStore.loadCollections(forceReload);
  await preferenceStore.loadPreferences();
  await featureFlagStore.loadCurrentFeatures();
}

onMounted(async() => {
  const user = await getCurrentUser();
  if (user) {
    userName.value = `${user.firstName} ${user.lastName}`;

    await accountStore.loadAccounts();
    await refreshAccountData();
  }
});

watch(currentAccountId, async (newId) => {
  if (newId) {
    await refreshAccountData(true);
  }
});

async function handleSignOut() {
  await signOut();

  router.push({ name: 'login' });
}

function handleChangeAccount() {
  accountStore.showSelector();
}

</script>
